import { RosterDetail } from 'api/worker'
import { Box, Flex, Heading, IconButton, Text, toast, Tooltip } from 'ui'
import { CalendarClockIcon, TrashIcon } from 'lucide-react'
import { format } from 'date-fns'
import { WorkerCard } from './WorkerCard'
import { AddWorkersModal } from './AddWorkersModal'
import { EditListModal } from './EditListModal'
import { WorkerEmptyState } from 'pages/ListDetailPage/WorkerEmptyState'
import { useDeactivateRosterMutation } from 'queries/worker'
import { useNavigate } from 'react-router'
import { AuthGuard } from 'components/auth'
import { PermissionEnum } from 'api/userPermissions'

export function ListDetails(props: { data: RosterDetail }) {
  const navigate = useNavigate()
  const { data } = props

  const { mutate: deactivateRoster } = useDeactivateRosterMutation(
    {
      rosterId: Number(data.id),
    },
    {
      onSuccess: () => {
        toast.success('Roster deleted')
        navigate(-1)
      },
      onError: () => {
        toast.error('Failed to delete roster')
      },
    }
  )

  const canDeleteList = data.workers.length === 0

  return (
    <>
      <Flex alignItems={'center'}>
        <Heading level={2} fontWeight={0}>
          {data.name}
        </Heading>
        <Box flex={1} />
        <EditListModal data={data} />
        <AuthGuard.Permission value={PermissionEnum.RequestSpecificWorker}>
          <Tooltip
            content={
              canDeleteList
                ? 'Delete list'
                : 'Remove all workers from list to delete'
            }
          >
            <IconButton
              disabled={!canDeleteList}
              onClick={() => deactivateRoster()}
              hoverBackgroundColor="error"
              color={'error'}
            >
              <TrashIcon size={18} />
            </IconButton>
          </Tooltip>
        </AuthGuard.Permission>
      </Flex>
      <Box display={'inline-flex'} mb={4}>
        <CalendarClockIcon size={18} />
        <Text ml={3}>
          List Created on {format(new Date(data.createdAt), 'MMM dd, yyyy')}
        </Text>
      </Box>
      <hr />
      <Flex mt={4} alignItems={'center'}>
        <Heading level={2} fontWeight={0}>
          Workers
        </Heading>
        <Box flex={1} />
        <AddWorkersModal data={data} />
      </Flex>
      <Box>
        {data.workers.map((worker) => (
          <WorkerCard
            data={worker}
            rosterId={Number(data.id)}
            key={worker.id}
          />
        ))}
      </Box>
      {data.workers.length === 0 ? <WorkerEmptyState /> : null}
    </>
  )
}
